import React from "react";
import "./projects.css";
import restaurant from '../../images/projects/project1.jpg'
import maskhera from '../../images/projects/project2.jpg'
import crud from '../../images/projects/project3.jpg'

const Projects =()=> {
  const projects = [
    {
      name: "Rick and Morty REST API",
      descripcion: "Consumo de API y simulación fetch",
      enlace: "https://johandry-developer.github.io/rick-and-morty",
      image: crud
    },
   
    {
      name: "Skull Café",
      descripcion: "Reservación web para restaurante",
      enlace: "https://johandry-developer.github.io/skull-cafe",
      image: restaurant
    },
    {
      name: "Maskhera Web",
      descripcion: "Un portafolio personal Wordpress.",
      enlace: "https://maskhera.com",
      image: maskhera
    },
  ];

  return (
    <section id="projects" className="projects">
      <h2>Proyectos</h2>
      <div className="projects-container">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <img className="img-project" src={project.image} alt={project.name}/>
            <div className="container-hover">
              <h3>{project.name}</h3>
              <p>{project.descripcion}</p>
              <a href={project.enlace} target="_blank" rel="noopener noreferrer">
                Ver Proyecto
              </a>
            </div>
           
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;